/*
 * Configuracion del modulo de BI
 */

import { value } from "./DataLibrary";

/*
 * colors
 */
export const C_AMARILLO = "#FFBB28";
export const C_AZUL = "#6600ff";
export const C_CELESTE = "#0088FE";
export const C_CELESTE_CLARO = "#80c3ff";
export const C_VERDE = "#00b392";
export const C_VERDE_CLARO = "#ccffcc";
export const C_NARANJA = "#FF8042";
export const C_ROJO = "#FF0000";
export const C_ROSA = "#ff9999";
export const C_ROSA_CLARO = "#ffcccc";
export const C_GRIS = "#a6a6a6";
export const C_BLACK = "#000000";

export const C_DECLARADO = C_CELESTE;
export const C_PAGADO = C_VERDE;
export const C_AFILIADOS = C_VERDE;
export const C_NO_AFILIADOS = C_ROJO;
export const C_HOMBRE = C_CELESTE;
export const C_MUJER = C_ROSA;
export const C_SIN_DATOS = C_GRIS;

/*
 * reducers
 */
export const R_DeclaradoPagado = {
	Declarado: item =>
		value("data.A$.f", item) +
		value("data.A$.m", item) +
		value("data.NA$.f", item) +
		value("data.NA$.m", item),
	Pagado: item => item.paid
};
export const R_AfiliadosNoAfiliados_money = {
	Afiliados: item => value("data.A$.f", item) + value("data.A$.m", item),
	"No Afiliados": item => value("data.NA$.f", item) + value("data.NA$.m", item)
};
export const R_AfiliadosNoAfiliados_cant = {
	Afiliados: item => value("data.Aq.f", item) + value("data.Aq.m", item),
	"No Afiliados": item => value("data.NAq.f", item) + value("data.NAq.m", item)
};
export const R_HombresMujeresAfiliadosNoafiliados_cant = {
	"Afiliados Hombres": item => value("data.Aq.m", item),
	"Afiliados Mujeres": item => value("data.Aq.f", item),
	"No Afiliados Hombres": item => value("data.NAq.m", item),
	"No Afiliados Mujeres": item => value("data.NAq.f", item)
};
export const R_NOafiliadoshombreNOafiliadosmujer_cant = {
	"No Afiliados Hombres": item => value("data.NAq.m", item),
	"No Afiliados Mujeres": item => value("data.NAq.f", item)
};
export const R_AfiliadoshombreAfiliadosmujer_cant = {
	"Afiliados Hombres": item => value("data.Aq.m", item),
	"Afiliados Mujeres": item => value("data.Aq.f", item)
};
export const R_AffiliadosActivosInactivosAVerificarTotales = {
	"Afiliados Activos": item => value("data.activo", item),
	"Afiliados Inactivos": item => value("data.inactivo", item),
	"Afiliados A Verificar": item => value("data.aVerificar", item)
};



// WEBPACK FOOTER //
// ./src/screens/biCharts/DataConfig.js